var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19L14.657 14.657M14.657 14.657C15.3998 13.9141 15.9891 13.0322 16.3912 12.0615C16.7932 11.0909 17.0002 10.0506 17.0002 8.99999C17.0002 7.94939 16.7932 6.90908 16.3912 5.93845C15.9891 4.96782 15.3998 4.08588 14.657 3.34299C13.9141 2.6001 13.0321 2.01081 12.0615 1.60877C11.0909 1.20672 10.0506 0.999786 8.99996 0.999786C7.94936 0.999786 6.90904 1.20672 5.93841 1.60877C4.96779 2.01081 4.08585 2.6001 3.34296 3.34299C1.84263 4.84332 0.999756 6.87821 0.999756 8.99999C0.999756 11.1218 1.84263 13.1567 3.34296 14.657C4.84329 16.1573 6.87817 17.0002 8.99996 17.0002C11.1217 17.0002 13.1566 16.1573 14.657 14.657Z",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlue);
export default __webpack_public_path__ + "static/media/search_icon_blue.b69911a18d29260d6a1a1100cec17750.svg";
export { ForwardRef as ReactComponent };